import script from "./CRM31_008POS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM31_008POS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__